import React from 'react';
import { motion } from 'framer-motion';
import { PenTool, Megaphone, Shield } from 'lucide-react';
export function Expertise() {
  return <section id="expertise" className="py-28 px-4 sm:px-6 lg:px-8 relative" data-id="element-106">
      {/* Decorative background blur */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-96 bg-amber-500/5 rounded-full blur-[100px] -z-10" data-id="element-107"></div>

      <div className="max-w-7xl mx-auto" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-109">
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 text-zinc-100" data-id="element-110">
            Core Expertise
          </h2>
          <div className="flex items-center justify-center gap-4" data-id="element-111">
            <div className="w-12 h-[1px] bg-zinc-700" data-id="element-112"></div>
            <div className="w-3 h-3 rotate-45 bg-amber-500" data-id="element-113"></div>
            <div className="w-12 h-[1px] bg-zinc-700" data-id="element-114"></div>
          </div>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8" data-id="element-115">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-start bg-zinc-900/40 backdrop-blur-md border border-zinc-800/80 rounded-2xl p-8 hover:bg-zinc-900/60 hover:border-amber-500/30 transition-all duration-300" data-id="element-116">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-500/20 to-amber-500/5 border border-amber-500/30 flex items-center justify-center mb-8 shadow-inner" data-id="element-117">
              <PenTool className="w-8 h-8 text-amber-500" data-id="element-118" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-zinc-100 mb-4" data-id="element-119">
              Content Writing
            </h3>
            <p className="text-zinc-400 leading-relaxed mb-6" data-id="element-120">
              Crafting compelling, authoritative, and precise content tailored
              for high-stakes political and governmental communications.
            </p>
            <ul className="space-y-3 text-zinc-300 w-full" data-id="element-121">
              <li className="flex items-start gap-3" data-id="element-122">
                <span className="text-amber-500 mt-1" data-id="element-123">•</span>
                <span data-id="element-124">Drafting official speeches & addresses</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-125">
                <span className="text-amber-500 mt-1" data-id="element-126">•</span>
                <span data-id="element-127">Creating impactful press releases</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-128">
                <span className="text-amber-500 mt-1" data-id="element-129">•</span>
                <span data-id="element-130">Synthesizing complex policy summaries</span>
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col items-start bg-zinc-900/40 backdrop-blur-md border border-zinc-800/80 rounded-2xl p-8 hover:bg-zinc-900/60 hover:border-amber-500/30 transition-all duration-300" data-id="element-131">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-500/20 to-amber-500/5 border border-amber-500/30 flex items-center justify-center mb-8 shadow-inner" data-id="element-132">
              <Megaphone className="w-8 h-8 text-amber-500" data-id="element-133" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-zinc-100 mb-4" data-id="element-134">
              Narrative Building
            </h3>
            <p className="text-zinc-400 leading-relaxed mb-6" data-id="element-135">
              Architecting long-term public narratives and managing perceptions
              through strategic media interventions.
            </p>
            <ul className="space-y-3 text-zinc-300 w-full" data-id="element-136">
              <li className="flex items-start gap-3" data-id="element-137">
                <span className="text-amber-500 mt-1" data-id="element-138">•</span>
                <span data-id="element-139">Long-term perception management</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-140">
                <span className="text-amber-500 mt-1" data-id="element-141">•</span>
                <span data-id="element-142">Comprehensive communication campaigns</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-143">
                <span className="text-amber-500 mt-1" data-id="element-144">•</span>
                <span data-id="element-145">Translating achievements into stories</span>
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col items-start bg-zinc-900/40 backdrop-blur-md border border-zinc-800/80 rounded-2xl p-8 hover:bg-zinc-900/60 hover:border-amber-500/30 transition-all duration-300" data-id="element-146">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-500/20 to-amber-500/5 border border-amber-500/30 flex items-center justify-center mb-8 shadow-inner" data-id="element-147">
              <Shield className="w-8 h-8 text-amber-500" data-id="element-148" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-zinc-100 mb-4" data-id="element-149">
              Government Media Strategy
            </h3>
            <p className="text-zinc-400 leading-relaxed mb-6" data-id="element-150">
              Navigating the complex landscape of state media operations with
              authority, discretion, and strategic foresight.
            </p>
            <ul className="space-y-3 text-zinc-300 w-full" data-id="element-151">
              <li className="flex items-start gap-3" data-id="element-152">
                <span className="text-amber-500 mt-1" data-id="element-153">•</span>
                <span data-id="element-154">Crisis communication management</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-155">
                <span className="text-amber-500 mt-1" data-id="element-156">•</span>
                <span data-id="element-157">High-level media relations</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-158">
                <span className="text-amber-500 mt-1" data-id="element-159">•</span>
                <span data-id="element-160">Electoral communication strategy</span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}